import { FC } from "react"

type Props = {
  padding?: string
  children: JSX.Element | JSX.Element[]
}

export const Container: FC<Props> = (props) => {
  return (
    <div className={"relative z-[2]" + props.padding}>{props.children}</div>
  )
}

Container.defaultProps = {
  padding: "2xl:p-6 p-4",
}
